import { render, staticRenderFns } from "./MortgageGuidanceSelectionPage.vue?vue&type=template&id=5680a008&scoped=true"
import script from "./MortgageGuidanceSelectionPage.vue?vue&type=script&lang=js"
export * from "./MortgageGuidanceSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageGuidanceSelectionPage.vue?vue&type=style&index=0&id=5680a008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680a008",
  null
  
)

export default component.exports